export const MB_32 = 32000000;

export const MB_8 = 8000000;

export const KYB_FIELD_MIME_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];
